<template>
    <div :class="$style.modal">
        <!--<div class="in-banner">-->
        <!--    <img src="../../assets/in-banner1.png" />-->
        <!--</div>-->

        <div class="in-head">
            <div v-if="select==1" class="in-head-text">当前共有{{ liveVideoExtra }}个直播</div>

            <!-- <a class="in-head-btn" @click="selected(2)" :class="{'active':select==2}">历史直播</a>
            <a class="in-head-btn" @click="selected(1)" :class="{'active':select==1}">正在直播</a> -->
            <div class="clearfix"></div>
        </div>
        <div style="background: #f0f3f9;">
            <liveLists :live-video-list="liveVideoList" />
            <!-- <historyLive v-if="select==2" /> -->
        </div>

        <div class="pagination-box" style=" padding-bottom: 20px;">

            <div style="width: 1200px; margin: auto; display: flex;">
                <a-pagination
                    v-if="select==1"
                    :total="liveVideoExtra"
                    :show-total="liveVideoExtra => `共 ${liveVideoExtra} 条`"
                    :page-size="pageSize"
                    class="agination"
                    @change="hotOnTableChanged"
                    v-model="pagination" />
            </div>
        </div>

    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import liveLists from './components/liveLists.vue';
    import historyLive from './components/historyLive.vue';

    export default {
        name: 'LiveVideoView',

        components: { liveLists, historyLive },
        data() {
            return {
                isActive: true,
                select: 1,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                pagination: 1,
                pageSize: 6,
                total: 10,
                spinning: true,
            };
        },

        computed: {
            ...mapState('liveVideo', ['liveVideoList', 'liveVideoExtra']),
            ...mapState('indexView', ['latestVideoList', 'indexVideoLoading']),
            ...mapState(['userInfo']),
        },

        watch: {},
        mounted() {
            this.handleLoadList();
            this.handleLoadLatestVideoList();
            window.removeEventListener('beforeunload', e => this.addViews('d',e))
        },

        methods: {
            ...mapActions('liveVideo', ['getliveVideoList']),
            // 加载列表
            handleLoadList(queries={}) {
                let queries1 = {};
                // const _this = this;
                const orgId = this.userInfo.org_id || '';

                queries1 = {
                    orgId: orgId,
                    ...queries,
                };
              


                this.getliveVideoList(queries1).catch(({ message }) => {
                    if (message) this.$message.error(message);
                });
            },

            ...mapActions('indexView', ['getLatestVideoLIst']),

            // 历史直播 就是最新列表
            handleLoadLatestVideoList() {
                // 打印请求参数
                let queries = {};
                // const _this = this;
                const orgId = this.userInfo.org_id || '';

                queries = {
                    orgId: orgId,
                    orderType: '1',
                };
                if (!this.userInfo.user_name) {
                    delete queries.orgId;
                }
                this
                    .getLatestVideoLIst(queries)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                        this.spinning = false;
                    });
            },
            selected(num) {
                this.select = num;
            },
            hotOnTableChanged(pagination, perPageNum) {
                const queries = {
                    pagination,
                    perPageNum,
                };

                this.handleLoadList(queries);
            },
        },
    };
</script>

<style lang="less" module>
    .modal {
        width: 100%;

        :global {
            .in-banner {
                max-width: 1180px;
                margin: 20px auto 0;
                height: 120px;
            }

            .in-head {
                max-width: 1180px;
                margin: 20px auto 0;
                height: auto;
            }

            .in-head a {
                display: block;
                width: 100px;
                margin-left: 10px;
                height: 36px;
                border-radius: 19px;
                float: right;
                color: #767676;
                border: 1px solid #c9c7c7;
                line-height: 36px;
                text-align: center;
            }

            .in-head-text {
                max-width: 400px;
                height: 38px;
                line-height: 38px;
                float: left;
                background: #c99;
                color: #818489;
                font-size: 18px;
                background: url(../../assets/icon-rec.png) no-repeat left;
                padding-left: 34px;
            }

            .in-head .active {
                border: 1px solid #165abb;
                background: #165abb;
                color: #fff;
            }

            .pagination-box {
                background: #f0f3f9;
                display: flex;
                justify-content: center;

                /* max-width: 1200px; */
                margin: auto;
            }

            .agination {
                margin: auto;
            }

            .broadcast-box {
                border: none !important;
                margin: auto;
                width: 100%;
                justify-content: center;
            }

            .pagination-box {
                margin: auto;
            }
        }
    }
</style>
